import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MdCalendarToday } from 'react-icons/md';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classes from './CustomDatePicker.module.scss';

const CustomDatePicker = (props) => {
    const { maxDate, minDate, onChange, onChangeRaw, placeholderText, selected } = props;
    return (
        <label className={classes.Container}>
            <DatePicker
                wrapperClassName={classes.DatePickerWrapper}
                className={classes.DatePicker}
                placeholderText={placeholderText}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={selected}
                onChange={onChange}
                onChangeRaw={onChangeRaw}
                dateFormat="dd/MM/yyyy"
                minDate={minDate}
                maxDate={maxDate}
                shouldCloseOnSelect={true}
                // isClearable={true}
            />
            <MdCalendarToday className={classes.Icon} />
        </label>
    );
};

CustomDatePicker.defaultProps = {
    placeholderText: '',
    selected: null,
    minDate: new Date('01-01-2000'),
    maxDate: new Date('01-01-2051'),
};

CustomDatePicker.propTypes = {
    selected: PropTypes.any,
    onChange: PropTypes.func,
    onChangeRaw: PropTypes.func,
    placeholderText: PropTypes.string,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
};

export default CustomDatePicker;
